import React from 'react';
import { Switch, Typography } from 'antd';

const { Text } = Typography;

const AutoResizeOnExpandControl = ({ editingWidget, setEditingWidget }) => (
  <div>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
      <Text strong>Redimensionar o gráfico ao expandir detalhes</Text>
      <Switch
        checked={editingWidget?.autoResizeOnExpand !== false}
        onChange={(checked) => setEditingWidget({ ...editingWidget, autoResizeOnExpand: checked })}
      />
    </div>
    <Text type="secondary" style={{ fontSize: '12px', marginTop: 4, display: 'block' }}>
      Quando desativado, os detalhes abrem sem aumentar o tamanho do gráfico.
    </Text>
  </div>
);

export default AutoResizeOnExpandControl;
